/**
 * @generated SignedSource<<0ff4be6c4126777960737912ae42bde9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarStatus_person$data = {
  readonly profile: {
    readonly givenName: string | null;
  } | null;
  readonly " $fragmentType": "CalendarStatus_person";
};
export type CalendarStatus_person$key = {
  readonly " $data"?: CalendarStatus_person$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarStatus_person">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CalendarStatus_person",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "givenName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Person",
  "abstractKey": null
};

(node as any).hash = "3d948b284e7b75eb6159fa98fcfa7d00";

export default node;
